import MenuItem from "./MenuItem";
import MenuItemButton from "./MenuItemButton";

MenuItem.Button = MenuItemButton;

export default MenuItem;
